export default "__VITE_ASSET__P5vczSDr__"